const PLANO_PAGAMENTO = {
  MENSAL: 'MENSAL',
  ANUAL: 'ANUAL',
};

export const objectsConstants = {
  STATUS: [
    { name: 'CRIADO', description: 'CRIADOS' },
    { name: 'EM_SEPARACAO', description: 'EM SEPARAÇÃO' },
    { name: 'A_FATURAR', description: 'CONFERIDO AGUARDANDO FATURAMENTO' },
    { name: 'FATURADO', description: 'FATURADO AGUARDANDO EXPEDIÇÃO' },
    { name: 'SEPARACAO_ATRASADA', description: 'SEPARAÇÕES ATRASADAS' },
    { name: 'FATURAMENTO_ATRASADO', description: 'FATURAMENTO ATRASADO' },
  ],
  STATUS_PEDIDO: [
    { value: '', label: 'Todas' },
    { value: 'CRIADO', label: 'CRIADO' },
    { value: 'EM_SEPARACAO', label: 'EM SEPARAÇÃO' },
    { value: 'A_FATURAR', label: 'A FATURAR' },
    { value: 'FATURADO', label: 'FATURADO' },
    { value: 'SEPARACAO_ATRASADA', label: 'SEPARAÇÃO ATRASADA' },
    { value: 'FATURAMENTO_ATRASADO', label: 'FATURAMENTO ATRASADO' },
  ],
  STATUS_PEDIDO_ALCIS: [
    { value: '', label: 'Todas' },
    { value: 'Expedido', label: 'Expedido' },
    { value: 'Reservado', label: 'Reservado' },
    { value: 'Cancelado', label: 'Cancelado' },
    { value: 'Conferido', label: 'Conferido' },
    { value: 'Separado', label: 'Separado' },
    { value: 'Planejamento concluido', label: 'Planejamento concluido' },
  ],
  STATUS_PEDIDO_DEVOLUCAO: [
    { label: 'Criado', value: 'CRIADO' },
    { label: 'Aprovado', value: 'APROVADO' },
    { label: 'Recusado', value: 'RECUSADO' },
  ],
  MODO_CONTROLE_ESTOQUE: [
    { label: 'WMS externo', value: 'WMS' },
    { label: 'Estoque interno', value: 'INTERNO' },
  ],

  // TIPO_PEDIDO: [
  //   { label: 'Comum', value: 'COMUM' },
  //   { label: 'Judicial', value: 'JUDICIAL' },
  //   { label: 'Domiciliar', value: 'DOMICILIAR' },
  // ],

  // TIPO_PEDIDO_FULL: [
  //   { label: 'Comum', value: 'COMUM' },
  //   { label: 'Judicial', value: 'JUDICIAL' },
  //   { label: 'Domiciliar', value: 'DOMICILIAR' },
  //   { label: 'Em Mapa', value: 'EM_MAPA' },
  //   { label: 'Mapa Estratégico', value: 'MAPA_ESTRATEGICO' },
  // ],
  TIPO_PEDIDO_EM_MAPA: 'MAPA',

  //ABILITY
  ABILITY_SOLICITAR_HP: 'Solicitar HP',
  ABILITY_TROCA_MAIS_MODELOS: 'Troca Mais Modelos',
  ABILITY_ESCOLHA_MODELO_TROCA: 'Escolha do modelos para troca',
  ABILITY_FINANCEIRO: 'Financeiro',
  ABILITY_REPARAR_OS: 'Reparar OS',
  ABILITY_CADASTRAR_OS: 'Cadastrar OS',
  ABILITY_IMPORTAR_PECA_DOC: 'Importar Peça Doc',
  ABILITY_EDITAR_CLIENTE: 'Editar dados Cliente',
  ABILITY_APROVAR_ORCAMENTO_OS: 'Aprovar orçamento da OS',
  ABILITY_EDITAR_COLABORADOR: 'Editar colaborador',
  ABILITY_FILTRO_POSTO: 'Filtro posto autorizado',
  ABILITY_CADASTAR_DOC: 'Cadastrar DOC',
  ABILITY_FINALIZAR_OS: 'Finalizar OS',
  ABILITY_FILTRO_CODIGO_SAP: 'Filtro Codigo SAP',
  ABILITY_SOLICITAR_TROCA_MODELO: 'Solicitar troca de modelo',
  ABILITY_CONFIGURACOES: 'Configurações',
  ABILITY_REJEITAR_PECA: 'Rejeitar Peça',
  ABILITY_DOC: 'DOC',
  ABILITY_TROCA_MODELO: 'Troca de Modelo',
  ABILITY_RELATORIO_FINANCEIRO: 'Relatório Financeiro',
  ABILITY_SOLICITAR_COMPRA_PECA: 'Cadastra compra peca',
  ABILITY_EXPIRAR_OS: 'Expirar OS',
  ABILITY_CANCELAR_OS: 'Cancelar OS',
  ABILITY_REPROVAR_TROCA_MODELO: 'Reprovar Troca de Modelo',
  ABILITY_CONFIGURAR_PERFIL: 'Configurar Perfil',
  ABILITY_ORDEM_SERVICO: 'Ordem Servico',
  ABILITY_ORDEM_SERVICO_VISUALIZACAO_POSTO:
    'Ordem de Serviço visualização de Posto Autorizado ',
  ABILITY_COMPRA_PECA_VISUALIZACAO_POSTO:
    'Compra de Peça visualização de Posto Autorizado',
  ABILITY_COMPRA_PECA: 'Compra de Peça',
  ABILITY_POSTO: 'Cadastro de posto autorizado',
  ABILITY_COLABORADORES: 'Cadastro de Colaborador',
  ABILITY_CADASTRO_RELOGIO: 'Cadastro de produto',
  ABILITY_CADASTRO_GRUPO_MARCAS: 'Cadastro de grupo de marcas',
  ABILITY_CADASTRO_MARCAS: 'Cadastro de marcas',
  ABILITY_HOME_TASK: 'Caixa de tarefas (Pagina inicial)',
  ABILITY_HOME_DOCS: 'Caixa de Docs (Pagina inicial)',
  ABILITY_HOME_COLABORADOR: 'Caixa de colaboradores(Pagina inicial)',
  ABILITY_POSTO_HOME: 'Caixa dados do Posto(Pagina Inicial)',
  ABILITY_HOME_SELECT_POSTO:
    'Caixa de seleção de Posto Autorizado(Pagina Inicial)',
  ABILITY_HOME_ORDEM_SERVICO:
    'Caixa de selecionar Ordem de Serviço(Pagina Inicial)',
  ABILITY_HOME_COMPRA_PECA:
    'Caixa de selecionar Compra de peça(Pagina Inicial)',
  ABILITY_CADASTRAR_POSTO_HABILITADO: 'Cadastrar Posto Habilitado',
  ABILITY_ORDEM_SERVICO_ASSOCIAR_POSTO_HABILITADO: 'Associar Posto Habilitado',
  ABILITY_VISUALIZAR_POSTOS_OS: 'Visualizar Postos(Ordem Servico)',
  ABILITY_VISUALIZAR_ESTOQUE_OS: 'Visualizar Estoque(Ordem Servico)',
  ABILITY_ALTERAR_STATUS_OS: 'Alterar Status de Ordem de Serviço',
  ABILITY_CADASTRO_DE_RELOGIO: 'Cadastro de Relogio',
  ABILITY_REATIVAR_OS: 'Reativar Ordem de Serviço',
  ABILITY_SOLICITAR_ATSP_BTN: 'SolicitarATSP Btn',

  STATUS_WMS: [
    { value: 'CRIADO', name: 'CRIADOS' },
    { value: 'EM_SEPARACAO', name: 'EM SEPARAÇÃO' },
    { value: 'A_FATURAR', name: 'CONFERIDO AGUARDANDO FATURAMENTO' },
    { value: 'FATURADO', name: 'FATURADO AGUARDANDO EXPEDIÇÃO' },
    { value: 'SEPARACAO_ATRASADA', name: 'SEPARAÇÕES ATRASADAS' },
    { value: 'FATURAMENTO_ATRASADO', name: 'FATURAMENTO ATRASADO' },
  ],

  PERFIS: [
    { value: 'ADMIN', name: 'Administrador' },
    { value: 'APROVADOR', name: 'Aprovador' },
    { value: 'SOLICITANTE', name: 'Solicitante (Apenas Pedido)' },
    { value: 'ADMIN_BIO', name: 'Administrador Biotech' },
  ],

  REOPEN: 'REOPEN',
  REPROVE: 'REPROVE',
  APROVE: 'APROVE',
  APROVADO: 'aprovado',
  REPROVADO: 'reprovado',
  DIAS: [
    { label: 'Segunda a Sexta', value: 'SEGUNDA_A_SEXTA' },
    { label: 'Segunda a Sábado', value: 'SEGUNDA_A_SABADO' },
    { label: 'Segunda-feira', value: 'SEGUNDA' },
    { label: 'Terça-feira', value: 'TERCA' },
    { label: 'Quarta-feira', value: 'QUARTA' },
    { label: 'Quinta-feira', value: 'QUINTA' },
    { label: 'Sexta-feira', value: 'SEXTA' },
    { label: 'Sabado', value: 'SABADO' },
    { label: 'Domingo', value: 'DOMINGO' },
  ],
  //FIM ABILITY
  USO_INDEVIDO: 6,
  PARTES: [
    { nome: 'PARAFUSO', qtd: 8 },
    { nome: 'PINO', qtd: 8 },
    { nome: 'TERMINAL', qtd: 2 },
  ],
  cnpjValidate: {
    name: 'cnpj',
    message: 'Campo obrigatório',
    type: 'cnpj',
    required: true,
  },
  SIM_NAO: [{ label: 'Não', value: false }, { label: 'Sim', value: true }],
  codeGoogle: 'AIzaSyCgj5WxP4p7O9K-9WZIry2zqdw4C2LbxIA',

  razaoSocialValidate: {
    name: 'razaoSocial',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  nomeFantasiaValidate: {
    name: 'nomeFantasia',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  inscricaoEstadualValidate: {
    name: 'inscricaoEstadual',
    message: 'Campo obrigatório',
    type: 'number',
    required: true,
  },
  inscricaoMunicipalValidate: {
    name: 'inscricaoMunicipal',
    message: 'Campo obrigatório',
    type: 'number',
    required: true,
  },
  emailComercialValidate: {
    name: 'emailComercial',
    message: 'Campo obrigatório',
    type: 'email',
    required: true,
  },
  telefoneComercialValidate: {
    name: 'telefoneComercial',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  // Address
  cepValidate: {
    name: 'cep',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  ruaValidate: {
    name: 'rua',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  numeroValidate: {
    name: 'numero',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  complementoValidate: {
    name: 'complemento',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  bairroValidate: {
    name: 'bairro',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  paisValidate: {
    name: 'pais',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  estadoValidate: {
    name: 'estado',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  cidadeValidate: {
    name: 'cidade',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  horaFuncionamentoValidate: {
    name: 'horaFuncionamento',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  messageCampoObrigatorio: 'Campos obrigatórios não foram preenchidos ',
  messageSucesso: 'Registro salvo com sucesso.',
  messageError: 'Ops, desculpe houve um erro interno ao processar requisição.',
  defaultFilter: {
    status: 'true',
  },
  PAIS_DEFAULT: { id: 1, nome: 'Brasil' },
  ROLE_REPRESENTANTE_LEGAL: 'ROLE_REPRESENTANTE_LEGAL',
  VIEW: 'VIEW',
  REPORT: 'REPORT',
  MENU_OS_ADMIN_MANAUS: 'MenuOSAdminManaus',
  MENU_DOC_ADMIN_MANAUS: 'MENU_DOC_ADMIN_MANAUS',
  MENU_DOC_ADMIN_MANAUS_POSTO: 'MENU_DOC_ADMIN_MANAUS_POSTO',
  MENU_OS_POSTO: 'MENU_OS_POSTO',
  ROLE_FINANCEIRO: 'ROLE_FINANCEIRO',
  ROLE_MANAUS: 'ROLE_MANAUS',
  ROLE_MANAUS_TROCA: 'ROLE_MANAUS_TROCA',
  ROLE_ASSISTENCIA_TECNICA_SAO_PAULO: 'ROLE_ASSISTENCIA_TECNICA_SAO_PAULO',
  ROLE_POSTO: 'ROLE_POSTO',
  ROLE_FINANCEIRO_POSTO: 'ROLE_FINANCEIRO_POSTO',
  ROLE_ADMIN: 'ROLE_ADMIN',
  MENU_COLABORADOR: 'MENU_COLABORADOR',
  EDIT_PROFILE: 'EDIT_PROFILE',
  ADMIN_CONSULTA: 'ADMIN_CONSULTA',
  ROLE_ADMIN_POSTO: 'ROLE_ADMIN_POSTO',
  ROLE_REPARAR_OS: 'ROLE_REPARAR_OS',
  CONSULTA_OS: 'CONSULTA_OS',
  PJ: 'PJ',
  PF: 'PF',
  pecaValidate: {
    name: 'peca',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  sintomaValidate: {
    name: 'sintoma',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  causaValidate: {
    name: 'causa',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  garantiaValidate: {
    name: 'garantia',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  solicitarPecaValidate: {
    name: 'solicitarPeca',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  servicoValidate: {
    name: 'servico',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  valorFinalValidate: {
    name: 'valorFinal',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  MONTH_ARRAY: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],

  UF: [
    { label: 'AC', value: 'AC' },
    { label: 'AL', value: 'AL' },
    { label: 'AP', value: 'AP' },
    { label: 'AM', value: 'AM' },
    { label: 'BA', value: 'BA' },
    { label: 'CE', value: 'CE' },
    { label: 'DF', value: 'DF' },
    { label: 'ES', value: 'ES' },
    { label: 'GO', value: 'GO' },
    { label: 'MA', value: 'MA' },
    { label: 'MT', value: 'MT' },
    { label: 'MS', value: 'MS' },
    { label: 'MG', value: 'MG' },
    { label: 'PA', value: 'PA' },
    { label: 'PB', value: 'PB' },
    { label: 'PR', value: 'PR' },
    { label: 'PE', value: 'PE' },
    { label: 'PI', value: 'PI' },
    { label: 'RJ', value: 'RJ' },
    { label: 'RN', value: 'RN' },
    { label: 'RS', value: 'RS' },
    { label: 'RO', value: 'RO' },
    { label: 'RR', value: 'RR' },
    { label: 'SC', value: 'SC' },
    { label: 'SP', value: 'SP' },
    { label: 'SE', value: 'SE' },
    { label: 'TO', value: 'TO' },
  ],

  TIPO_PESSOA_ARRAY: [
    { name: 'PF', nome: 'Pessoa física' },
    { name: 'PJ', nome: 'Pessoa jurídica' },
    { name: 'TODOS', nome: 'Todos' },
  ],
  QUESTIONARIO_PESQUISA_ARRAY: [
    { id: 'ATENDIMENTO', label: 'Atendimento' },
    { id: 'PRAZO', label: 'Prazo' },
    { id: 'PRECO', label: 'Preço' },
    { id: 'QUALIDADE', label: 'Qualidade' },
  ],
  ROLES_POSTO: [
    { id: 'ATENDENTE', nome: 'Atendente' },
    { id: 'ROLE_REPRESENTANTE_LEGAL', nome: 'Responsável' },
    { id: 'CENTRO_TECNICO', nome: 'Técnico' },
  ],
  ROLES_ADMIN: [
    { id: 'ROLE_ADMIN', nome: 'Administrador' },
    { id: 'ROLE_MANAUS', nome: 'Manaus' },
    { id: 'ROLE_MANAUS_TROCA', nome: 'Manaus troca de modelo' },
    {
      id: 'ROLE_ASSISTENCIA_TECNICA_SAO_PAULO',
      nome: 'Assistência Tec São Paulo',
    },
    {
      id: 'ADMIN_CONSULTA',
      nome: 'Consulta OS',
    },
  ],
  HOME_MANAUS: 'HOME_MANAUS',
  EDIT_DOC: 'EDIT_DOC',
  IMPORT_PECA: 'IMPORT_PECA',
  HOME_MANAUS_TROCA: 'HOME_MANAUS_TROCA',
  MENU_MANAUS_TROCA: 'MENU_MANAUS_TROCA',
  MENU_SAO_PAULO_DOC: 'MENU_SAO_PAULO_DOC',
  HABILITADO: 'HABILITADO',
  CREDENCIADO: 'CREDENCIADO',
  PLANO_PAGAMENTO: PLANO_PAGAMENTO,
  STATUS_COLETA_DEVOLUCAO: [
    { value: 'PENDENTE', label: 'Pendente' },
    { value: 'COLETADO', label: 'Coletado' },
    { value: 'CANCELADO', label: 'Cancelado' },
  ],
  TIPO_PEDIDO: [
    { value: 'MAPA', label: 'MAPA' },
    { value: 'AVULSO', label: 'AVULSO' },
  ],

  GRUPO_PEDIDO_MAPA: [
    {
      value: 'MEDICAMENTOS_PORTARIA_344_98',
      label: 'Medicamentos Portaria 344/98',
    },
    { value: 'MEDICAMENTOS', label: 'Medicamentos' },
    { value: 'ALMOXARIFADO', label: 'Almoxarifado' },
  ],

  GRUPO_PEDIDO_AVULSO: [
    { value: 'DOMICILIAR', label: 'Domiciliar' },
    { value: 'INSULINAS', label: 'Insulinas' },
    { value: 'JUDICIAL', label: 'Judicial' },
    {
      value: 'MEDICAMENTOS_PORTARIA_344_98',
      label: 'Medicamentos Portaria 344/98',
    },
    { value: 'MEDICAMENTOS', label: 'Medicamentos' },
    {
      value: 'MEDICAMENTOS_ESTRATEGICOS',
      label: 'Medicamentos Estratégicos',
    },
    { value: 'ALMOXARIFADO', label: 'Almoxarifado' },
    { value: 'COMPLEMENTAR', label: 'Complementar' },
  ],
};
export const constHelper = {
  ROLE_ADMIN: 'Administrador',
  ROLE_REPRESENTANTE_LEGAL: 'Responsável',
  CENTRO_TECNICO: 'Técnico',
  ROLE_MANAUS: 'Manaus',
  ATENDENTE: 'Atendente',
  ROLE_MANAUS_TROCA: 'Manaus troca',
  ROLE_ASSISTENCIA_TECNICA_SAO_PAULO: 'Assistência SP',
  ADMIN_CONSULTA: 'Consulta OS',
};

export const responsibleConstant = {
  nomeValidate: {
    name: 'nome',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  dataNascimentoValidate: {
    name: 'dataNascimento',
    message: 'Campo obrigatório',
    type: 'date',
    required: true,
  },
  cpfValidate: {
    name: 'cpf',
    message: 'Campo obrigatório',
    type: 'cpf',
    required: true,
  },
  emailValidate: {
    name: 'email',
    message: 'Email inválido',
    type: 'email',
    required: true,
  },
  confirmarEmailValidate: {
    name: 'confirmarEmail',
    message: 'Email inválido',
    type: 'email',
    required: true,
  },
  celularValidate: {
    name: 'celular',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  senhaValidate: {
    name: 'senha',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
  confirmarSenhaValidate: {
    name: 'confirmarSenha',
    message: 'Campo obrigatório',
    type: 'text',
    required: true,
  },
};
